import { Instagram, MessageCircle } from "lucide-react";
import { motion } from "framer-motion";
import { CNPJ, IG_IDEALIZE, IG_SPEED, WHATSAPP_LABEL, waLink } from "@/lib/brand";
import { MaskLinesInView } from "./MaskInView";

export const PromiseSection = () => (
  <section data-testid="promise-section" className="grain relative overflow-hidden bg-[#07080f] py-28 sm:py-44">
    <div className="pointer-events-none absolute left-1/2 top-1/2 h-[480px] w-[480px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[#8b5cf6]/20 blur-[140px]" />
    <div className="relative mx-auto max-w-[1400px] px-5 sm:px-10">
      <p className="text-xs tracking-[0.35em] text-zinc-400">SPEED MAX & IDEALIZE</p>
      <h2 data-testid="promise-phrase" className="mt-6 font-display text-[12vw] sm:text-7xl lg:text-[7.5rem] font-extrabold tracking-tight leading-[0.95]">
        <MaskLinesInView lines={["Com você", "e para você,"]} />
        <MaskLinesInView lines={["sempre."]} delay={0.24} lineClass="grad-text" />
      </h2>
    </div>
  </section>
);

export const Footer = () => (
  <footer id="contato" data-testid="site-footer" className="border-t border-white/10 bg-[#07080f]">
    <div className="mx-auto grid max-w-[1400px] grid-cols-1 gap-12 px-5 sm:px-10 py-16 md:grid-cols-12">
      <div className="md:col-span-5">
        <div className="flex items-center gap-3">
          <img src="/brand/speedmax-icon.png" alt="Speed Max" className="h-10 w-10" />
          <span className="font-display text-lg font-bold">SPEED MAX</span>
        </div>
        <p className="mt-4 max-w-sm text-sm text-zinc-400">Streaming desde 2017. Atendimento 100% online — loja sem endereço físico.</p>
        <motion.a whileHover={{ x: 6 }} data-testid="footer-whatsapp-link" href={waLink("Olá! Vim pelo site e gostaria de atendimento.")} target="_blank" rel="noreferrer" className="mt-8 inline-flex items-center gap-3 font-display text-2xl sm:text-3xl font-bold">
          <MessageCircle className="h-7 w-7 text-[#25D366]" /> {WHATSAPP_LABEL}
        </motion.a>
      </div>
      <div className="md:col-span-4">
        <p className="text-xs tracking-[0.3em] text-zinc-400">INSTAGRAM</p>
        <ul className="mt-4 space-y-3 text-sm">
          <li><a data-testid="footer-ig-speedmax" href={IG_SPEED.url} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 text-zinc-200 hover:text-cyan-300"><Instagram className="h-4 w-4" />{IG_SPEED.handle} · Speed Max</a></li>
          <li><a data-testid="footer-ig-idealize" href={IG_IDEALIZE.url} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 text-zinc-200 hover:text-cyan-300"><Instagram className="h-4 w-4" />{IG_IDEALIZE.handle} · Idealize</a></li>
        </ul>
      </div>
      <div className="md:col-span-3">
        <p className="text-xs tracking-[0.3em] text-zinc-400">EMPRESA</p>
        <p data-testid="footer-cnpj" className="mt-4 text-sm text-zinc-200">CNPJ {CNPJ}</p>
        <a data-testid="footer-admin-link" href="/admin" className="mt-3 inline-block text-xs text-zinc-400 hover:text-zinc-200">Área do administrador</a>
      </div>
    </div>
    <div className="border-t border-white/10 py-6 text-center text-xs text-zinc-400">© {new Date().getFullYear()} Speed Max · Idealize Personalizados</div>
  </footer>
);
